import { render, staticRenderFns } from "./PriceRangeFilter.vue?vue&type=template&id=dd59c3d0&lang=pug"
import script from "./PriceRangeFilter.vue?vue&type=script&lang=js"
export * from "./PriceRangeFilter.vue?vue&type=script&lang=js"
import style0 from "./PriceRangeFilter.vue?vue&type=style&index=0&id=dd59c3d0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports